import React from 'react';

function AboutPage() {
  return (
    <section className="py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="section-title">About Family Ring</h2>
          <p className="text-muted">A private home for your family’s stories.</p>
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-md-6">
            <div className="feature-card">
              <h5>Why we built it</h5>
              <p>Memories shouldn’t get lost in group chats or giant feeds. Family Ring makes it simple to capture your family history and important moments and keep them in a place that’s private by default.</p>
              <h5 className="mt-3">What you can do</h5>
              <ul className="mb-0">
                <li>Capture memories in video and photos</li>
                <li>Interview your relatives with guided prompts</li>
                <li>Share with the people who matter most</li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 text-center">
            <img src="/brand/features/relive.svg" alt="Family timelines" className="feature-illustration" />
          </div>
        </div>
        <p className="text-center mt-4">Get in touch: <a href="mailto:support@familyring.io">support@familyring.io</a></p>
      </div>
    </section>
  );
}

export default AboutPage;
